import React from "react";
import { Box, Typography, Button } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import LogoutIcon from "@mui/icons-material/Logout";
import { useImpersonation } from "../../contexts/ImpersonationContext";

/**
 * Banner sticky imposible de ocultar mientras hay impersonation activa.
 * Va en la parte superior global de la app — encima del Layout.
 */
export default function ImpersonationBanner() {
  const { isActive, actingAsUser, remainingMs, stop } = useImpersonation();
  if (!isActive) return null;

  const name = actingAsUser
    ? `${actingAsUser.name || ""} ${actingAsUser.lastname || ""}`.trim() ||
      actingAsUser.email ||
      "—"
    : "—";

  const remainingLabel = remainingMs == null ? "" : formatRemaining(remainingMs);

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 2000,
        width: "100%",
        background: "linear-gradient(90deg, #f59e0b 0%, #d97706 100%)",
        color: "#fff",
        boxShadow: "0 2px 12px rgba(0,0,0,0.2)",
        px: { xs: 1.5, md: 2.5 },
        py: 1,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        flexWrap: "wrap",
      }}
    >
      <WarningAmberIcon sx={{ fontSize: 22 }} />
      <Box sx={{ display: "flex", flexDirection: "column", lineHeight: 1.15, flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontSize: 13, fontWeight: 700, letterSpacing: 0.2 }}>
          Estás actuando como {name}
        </Typography>
        {remainingLabel && (
          <Typography sx={{ fontSize: 11, opacity: 0.95 }}>
            {remainingLabel} restantes · todas tus acciones quedan auditadas
          </Typography>
        )}
      </Box>
      <Button
        size="small"
        onClick={stop}
        startIcon={<LogoutIcon sx={{ fontSize: 16 }} />}
        sx={{
          color: "#fff",
          backgroundColor: "rgba(255,255,255,0.2)",
          "&:hover": { backgroundColor: "rgba(255,255,255,0.32)" },
          textTransform: "none",
          fontWeight: 700,
          fontSize: 12,
          px: 1.5,
        }}
      >
        Salir
      </Button>
    </Box>
  );
}

function formatRemaining(ms) {
  const total = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  if (h <= 0) return `${m} min`;
  return `${h}h ${m}m`;
}
